<script>
export default {
  components: {},
  props: {
    objeto: {
      type: Object,
    },
  },
  data() {
    return {
      
    };
  },
}
</script>

<template>
  <div class="row mt-4">
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Nombre</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.nombre"
          id="nombre"
          placeholder="Nombre"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Email</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.email"
          id="email"
          placeholder="Email"
        ></b-form-input>
      </div>
    </div>
    <div class="col-sm-12 col-md-4">
      <b><label class="form-check-label">Contraseña</label> </b>
      <div class="mb-4">
        <b-form-input
          v-model="objeto.password"
          id="password"
          placeholder="Contraseña"
        ></b-form-input>
      </div>
    </div>
  </div>
</template>
